var React = require('react');

function NavIconsExperienceOverview (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m11.84 1.75a10.25 10.25 0 1 0 10.41 10.09 10.27 10.27 0 0 0 -10.41-10.09zm.3 19.41a9.15 9.15 0 0 1 -4.76-1.26l1.69-1.73a4.25 4.25 0 0 0 2.12.76 2.3 2.3 0 0 0 .37 0 4.49 4.49 0 0 0 2.85-1 6.36 6.36 0 0 0 .87-8.93 17.28 17.28 0 0 0 -3.77-3.42l-.9-.58.06 1.07a8.63 8.63 0 0 1 -2.21 5.58 4.31 4.31 0 0 0 -.23 5.76l-1.8 1.85a9.13 9.13 0 1 1 5.69 1.88zm-2.85-8.85a10.4 10.4 0 0 0 2.42-5.26 15.81 15.81 0 0 1 2.73 2.63 5.26 5.26 0 0 1 -.72 7.41 3.43 3.43 0 0 1 -2.44.77 3.33 3.33 0 0 1 -1.44-.48l.87-.9a1.72 1.72 0 1 0 -.79-.75l-.9.92a3.26 3.26 0 0 1 .27-4.34zm1.64 2.69a.48.48 0 0 1 .48-.47.47.47 0 1 1 0 .94.48.48 0 0 1 -.48-.47z"}));
}

NavIconsExperienceOverview.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = NavIconsExperienceOverview;

NavIconsExperienceOverview.default = NavIconsExperienceOverview;
